import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import FreeScrollBar from 'react-free-scrollbar';
import $ from 'jquery';

import UserMenuOptions from './UserMenuOptions';
import ClassroomMenuOptions from './ClassroomMenuOptions';
import { SIZE } from '../../../const';

const SCROLL_INIT_POSITION = 'top left';

class MenuBody extends React.Component {
  constructor(context, props) {
    super(context, props);
    this.resizeHandler = this.resizeHandler.bind(this);
    let height = $(window).height() - SIZE.MENU_HEADER;
    this.state = {
      height: `${height}px`,
      width: '100%'
    };
    $(window).resize(this.resizeHandler);
  }

  static propTypes = {
    route: PropTypes.string,
    inClassroom: PropTypes.bool
  };

  resizeHandler() {
    const { height } = this.state;

    let newHeight = $(window).height() - SIZE.MENU_HEADER;
    if (newHeight !== height) {
      this.setState({ height: `${newHeight}px` });
    }
  }

  renderMenuBody() {
    const { inClassroom } = this.props;

    return (
      <div className="inner">
        <CSSTransitionGroup transitionName="menu" transitionEnterTimeout={500} transitionLeaveTimeout={500}>
          {inClassroom ? <ClassroomMenuOptions /> : null}
          <UserMenuOptions />
        </CSSTransitionGroup>
      </div>
    );
  }

  render() {
    const { route } = this.props;
    const { height, width } = this.state;

    if (!route) return;

    return (
      <div style={{ height: height, width: width }}>
        <FreeScrollBar className="scroll" autohide={true} fixed={true} start={SCROLL_INIT_POSITION}>
          {this.renderMenuBody()}
        </FreeScrollBar>
      </div>
    );
  }
}

export default connect(mapStateToProps)(MenuBody);

function mapStateToProps(state) {
  return {
    route: state.router.location.pathname,
    inClassroom: state.router.inClassroom
  };
}
